import BubbleService from "@/services/Bubble/BubbleService";


class UpgradLoanManagementService extends BubbleService {

    constructor() {
        super();
    }

    findContractCode = async (email:string,cccd:string) => {
        return await this.postWf('find_contract_code',{email,cccd})
    }

    findApplicationByContractCode = async (contractCode:string) => {
        return await this.postWf('find_upgrad_application_by_contract_code',{contractCode})
    }
}

export default UpgradLoanManagementService;